import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeLoaderService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  private loadStyle(href: string): Promise<void> {
    return new Promise((resolve) => {
      const body = document.getElementsByTagName('body')[0];

      const link = this.renderer.createElement('link');

      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.classList.add('theme-css');
      link.href = `${href}?v=${Date.now()}`;

      link.onload = () => {
        document.body.offsetHeight; // Trigger reflow
        resolve();
      };

      link.onerror = () => resolve(); // Don't block the app if a stylesheet fails

      body.appendChild(link);
    });
  }

  async initTheme(notCaixa = false): Promise<void> {
    const sigla = localStorage.getItem('sigla');
    const body = document.getElementsByTagName('body')[0];
    const existingThemes = body.querySelectorAll('link.theme-css');
    existingThemes.forEach((link) => link.remove());

    const loads: Promise<void>[] = [];

    // Always load default
    loads.push(this.loadStyle('assets/custom.css'));

    // Conditionally load CAIXA
    if (sigla === 'CAIXA' && !notCaixa) {
      console.log('CAIXA THEME');
      loads.push(this.loadStyle('assets/custom-caixa.css'));
    }

    await Promise.all(loads);
  }

  public async getLogoColor() {
    // Select the specific image (the one in your example)

    const logo = await new Promise<HTMLImageElement>((resolve) => {
      const interval = setInterval(() => {
        const el = document.querySelector<HTMLImageElement>(
          'img.img-fluid.d-none.d-lg-block[src="/assets/img/banners/home/banner.png"]'
        );
        if (el) {
          clearInterval(interval);
          resolve(el);
        }
      }, 50);
    });

    await new Promise<void>((resolve, reject) => {
      if (logo.complete) return resolve(); // Already loaded
      logo.onload = () => resolve();
      logo.onerror = () => reject();
    });

    if (!logo) return;
    // Loop through the logo images

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    if (!context) return;

    canvas.width = logo.naturalWidth;
    canvas.height = logo.naturalHeight;
    context.drawImage(logo, 0, 0);

    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    const colorFrequency: Record<string, number> = {};
    let dominantColor = '';
    let maxFrequency = 0;

    for (let i = 0; i < data.length; i += 4) {
      const red = data[i];
      const green = data[i + 1];
      const blue = data[i + 2];

      const color = this.rgbToHex(red, green, blue);
      colorFrequency[color] = (colorFrequency[color] || 0) + 1;
    }

    // Find dominant color
    for (const color in colorFrequency) {
      if (colorFrequency[color] > maxFrequency) {
        maxFrequency = colorFrequency[color];
        dominantColor = color;
      }
    }

    // Set the CSS variable
    document.documentElement.style.setProperty('--logo-color', dominantColor);
  }

  private rgbToHex(r: number, g: number, b: number) {
    return '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');
  }
}
